export const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:8000';

/** True only for an optimized Vite production build. */
export const IS_PRODUCTION = import.meta.env.PROD;
export const MARTIN_URL = import.meta.env.VITE_MARTIN_URL || 'http://localhost:3000';

/**
 * URL de la frontiere publique des tuiles. Le nom d'environnement historique
 * VITE_MARTIN_URL est conserve pour compatibilite, mais le navigateur ne doit
 * jamais joindre Martin directement : `/tiles` est servi par le backend.
 */
export function territoryTileUrl(territoryCode: string, source: string): string {
  if (!/^[0-9A-Za-z]{2,5}$/.test(territoryCode)) {
    throw new Error('Code territoire invalide pour une source de tuiles');
  }
  if (!/^[a-z_]+$/.test(source)) {
    throw new Error('Identifiant de source de tuiles invalide');
  }
  return `${MARTIN_URL}/${territoryCode}/${source}/{z}/{x}/{y}.pbf`;
}

/** Ajoute le JWT uniquement aux requetes envoyees vers la frontiere tuiles. */
export function authenticatedMapRequest(
  url: string,
): { url: string; headers?: Record<string, string> } {
  if (!url.startsWith(`${MARTIN_URL}/`)) return { url };

  const token = typeof localStorage === 'undefined'
    ? null
    : localStorage.getItem('terravision_token');
  return token
    ? { url, headers: { Authorization: `Bearer ${token}` } }
    : { url };
}
export const CESIUM_BASE_URL = import.meta.env.VITE_CESIUM_BASE_URL || '/cesium';

/** Commune pilote chargée par défaut au démarrage (DEMO 78124). */
export const DEFAULT_TERRITORY_CODE =
  import.meta.env.VITE_DEFAULT_TERRITORY_CODE || '78124';

export const MAP_STYLE =
  'https://data.geopf.fr/annexes/ressources/vectorTiles/styles/PLAN.IGN/standard.json';

export const INITIAL_VIEW = {
  longitude: 2.03,
  latitude: 48.95,
  zoom: 13,
};

export const DPE_COLORS: Record<string, string> = {
  A: '#009B4D',
  B: '#33CC33',
  C: '#CCE500',
  D: '#FFCC00',
  E: '#FF9933',
  F: '#FF3300',
  G: '#CC0000',
};
